var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.5H12V20.5H23.5V3.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21H13.5C13.2236 21 13 20.7764 13 20.5C13 20.2236 13.2236 20 13.5 20H23V4H13.5C13.2236 4 13 3.77637 13 3.5C13 3.22363 13.2236 3 13.5 3H23.5C23.7764 3 24 3.22363 24 3.5V20.5C24 20.7764 23.7764 21 23.5 21Z",
    fill: "#177848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0L0 2.6087V21.3913L14 24V0Z",
    fill: "#177848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 2.6087V2.8587L14 0.25V0L0 2.6087Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H13V7H17V5Z",
    fill: "#177848"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5H18V7H22V5Z",
    fill: "#177848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8H13V10H17V8Z",
    fill: "#177848"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8H18V10H22V8Z",
    fill: "#177848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11H13V13H17V11Z",
    fill: "#177848"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H18V13H22V11Z",
    fill: "#177848"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H13V16H17V14Z",
    fill: "#177848"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H18V16H22V14Z",
    fill: "#177848"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H13V19H17V17Z",
    fill: "#177848"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17H18V19H22V17Z",
    fill: "#177848"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 21.3906L14 23.9993V23.7493L0 21.1406V21.3906Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21C23.7764 21 24 20.7764 24 20.5V13L14 3V21H23.5Z",
    fill: "url(#paint0_linear_3369_8511)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35773 12.4995L9.65533 8.36377L9.62634 8.34766L7.8797 8.47241L6.50006 10.9557L5.22571 8.66199L3.57593 8.77979L5.6424 12.4995L3.57593 16.2192L5.22571 16.337L6.50006 14.0433L7.8797 16.5266L9.62634 16.6514L9.65533 16.6353L7.35773 12.4995Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M14 0L0 2.6087V21.3913L14 24V0Z",
    fill: "url(#paint1_linear_3369_8511)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3H14V0L0 2.6087V21.3913L14 24V21H23.5C23.7764 21 24 20.7764 24 20.5V3.5C24 3.22363 23.7764 3 23.5 3Z",
    fill: "url(#paint2_linear_3369_8511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3369_8511",
    x1: 9.5,
    y1: 7.5,
    x2: 23.3536,
    y2: 21.3536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3369_8511",
    x1: -0.000815525,
    y1: 11.9995,
    x2: 14,
    y2: 11.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3369_8511",
    x1: -1.56345,
    y1: 5.96153,
    x2: 25.0454,
    y2: 18.3694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excelIcon.f6cd477158200634c6c5e39e08af0239.svg";
export { ForwardRef as ReactComponent };